import { render, staticRenderFns } from "./SingleView.vue?vue&type=template&id=65739636&scoped=true&"
import script from "./SingleView.vue?vue&type=script&lang=ts&"
export * from "./SingleView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65739636",
  null
  
)

export default component.exports